<template>
	<div class="brand-memo">
		<div class="brand-memo__box">
			<div class="brand-memo__right">
				<p class="brand-memo__title">관리자 댓글</p>
				<i class="fa fa-commenting" aria-hidden="true"></i>
			</div>
			<div class="brand-memo__left">
				<div class="brand-memo__input">
					<textarea
						placeholder="댓글을 입력하세요"
						v-model="commentInput"
					></textarea>
					<button class="btn btn-main" @click="commentRegister">
						입력
					</button>
				</div>
				<p class="brand-memo__no" v-if="memoList.length === 0">
					입력된 댓글이 없습니다
				</p>
				<div class="brand-memo__list" v-else>
					<div
						class="brand-memo__item"
						v-for="(memo, index) in memoList"
						:key="index"
					>
						<div class="brand-memo__name">
							<strong class="brand-memo__nickName">{{
								memo.nickName
							}}</strong>
							/ 등록 : {{ memo.createdAt }} / 수정:
							{{ memo.updatedAt || '-' }}
						</div>
						<div class="brand-memo__comment">
							<textarea :value="memo.memo" ref="memo"></textarea>
							<button
								v-if="adminRegister === memo.admin_account_id"
								class="btn blue"
								@click="() => commentEdit(memo.id, index)"
							>
								수정
							</button>
							<button
								class="btn"
								@click="() => commentDelete(memo.id)"
							>
								삭제
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import moment from 'moment';
	import { mapState } from 'vuex';

	export default {
		props: {
			brandId: {
				type: String,
				required: true,
			},
		},
		computed: {
			...mapState({
				adminRegister: state => state.login.idRegister,
			}),
		},
		data() {
			return {
				memoList: [],
				refType: 'brand',
				refId: this.brandId,
				commentInput: '',
			};
		},
		created() {
			this.getMemoList();
		},
		methods: {
			parsingDate(date) {
				return date
					? moment(date, 'YYYYMMDDHHmmss').format(
							'YYYY-MM-DD HH:mm:ss'
						)
					: '-';
			},
			async getMemoList() {
				try {
					const { data } = await this.$axiosSupport.get(
						`/admin/memo?ref_type=${this.refType}&ref_id=${this.refId}`
					);
					this.memoList = data.admin_memos.map(item => {
						item.modifyMode = false;
						item.createdAt = moment(item.created_at).format(
							'YYYY.MM.DD HH:mm:ss'
						);
						item.updatedAt =
							item.created_at === item.updated_at
								? ''
								: moment(item.updated_at).format(
										'YYYY.MM.DD HH:mm:ss'
									);
						return item;
					});
				} catch (error) {
					console.error(error);
					alert(
						'댓글을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async commentRegister() {
				if (!this.commentInput.trim()) {
					alert('댓글을 입력해주세요');
					return;
				}
				try {
					const params = {
						admin_memo: {
							ref_type: this.refType,
							ref_id: this.refId,
							memo: this.commentInput,
						},
					};
					await this.$axiosSupport.post('/admin/memo', params);
					this.getMemoList();
					this.commentInput = '';
				} catch (error) {
					console.error(error);
					alert(
						'댓글을 등록하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async commentEdit(id, idx) {
				if (!this.$refs.memo[idx].value.trim()) {
					alert('댓글을 입력해주세요');
					return;
				}
				try {
					const params = {
						admin_memo: {
							memo: this.$refs.memo[idx].value,
						},
					};
					await this.$axiosSupport.put(`/admin/memo/${id}`, params);
					this.getMemoList();
				} catch (error) {
					console.error(error);
					alert(
						'댓글을 수정하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async commentDelete(id) {
				if (!confirm('정말 해당 댓글을 삭제하나요?')) return;
				try {
					await this.$axiosSupport.delete(`/admin/memo/${id}`);
					this.getMemoList();
				} catch (error) {
					console.error(error);
					alert(
						'댓글을 삭제하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.brand-memo {
		height: 100%;
		border-top: 1px solid #e9e9e9;
		padding: 20px;

		&__box {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
			border: 1px solid #e9e9e9;
			border-radius: 5px;
			padding: 20px;
			background-color: #f9f9f9;
		}

		&__right {
			width: 100px;
			display: flex;
			flex-direction: column;
			align-items: center;
		}

		&__left {
			display: flex;
			flex-direction: column;
			gap: 20px;
			width: 100%;
			padding: 20px;
		}

		&__title {
			font-size: 16px;
			font-weight: bold;
			color: #333;
		}

		.fa-commenting {
			font-size: 50px;
			margin-top: 20px;
		}

		&__comment {
			display: flex;
			gap: 10px;
			align-items: center;
			justify-content: center;
		}

		&__no {
			margin: 0 auto;
			text-align: center;
			font-size: 16px;
			color: #787777;
			margin-top: 30px;
		}

		&__input {
			display: flex;
			gap: 10px;
			align-items: center;
			justify-content: center;
			border-bottom: 1px solid #e9e9e9;
			padding-bottom: 30px;
		}

		&__nickName {
			font-size: 14px;
			font-weight: bold;
			color: #333;
		}

		&__item {
			display: flex;
			flex-direction: column;
			margin-bottom: 20px;
		}
	}
</style>
